import { Text, TextType } from 'ui-components/components/text';

import styles from './styles.module.css';

/**
 * @param {object} props
 * @param {React.ReactNode|import('react-intl').MessageDescriptor} props.children
 * @returns {JSX.Element}
 */
export const StepHeader = ({ children }) => {
  return <Text className={styles['step-header']} textType={TextType.H2} value={children} />;
};
